import classnames from 'classnames';
import * as React from 'react';

interface ISectionProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  variant?: 'alt' | 'dark' | 'highlight' | 'highlight-dark';
  bordered?: boolean;
}
/**
 * `Section` groups related items together
 */
export const Section = React.forwardRef<HTMLDivElement, ISectionProps>(function SectionComp(
  { className, variant, bordered, ...props },
  ref
) {
  return (
    <div
      className={classnames('Section', variant && `Section--${variant}`, bordered && 'Section--border', className)}
      {...props}
      ref={ref}
    />
  );
});

export default Section;
